import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "panel-bg" }
const _hoisted_2 = { class: "icons-wrapper icons-left" }
const _hoisted_3 = { class: "icons-wrapper icons-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-panel box-shadow-transition", {
      [`${_ctx.className}`]: !!_ctx.className
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["panel-content", {
          'center-y': _ctx.centerY
        }])
      }, [
        _createElementVNode("div", {
          class: "panel-title-wrapper",
          style: _normalizeStyle({ width: _ctx.contentWidth })
        }, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "panel-title",
                style: _normalizeStyle({
              fontSize: _ctx.titleFontSize || undefined
            }),
                onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateInfoPanel()))
              }, _toDisplayString(_ctx.title), 37))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "icons-left")
          ]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "icons-right")
          ])
        ], 4),
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ])
  ], 2))
}